import { Box, BoxProps } from '@mui/material';
import styled from 'styled-components';

export const FlexBoxRow = styled(Box)(({ theme, sx }) => {
  const sxl: BoxProps['sx'] | object = sx || {};
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    ...theme.unstable_sx({
      ...sxl,
    }),
  };
});
